import { ThemeIcon, Tooltip } from "@mantine/core";
import {
  IconBulb,
  IconPlug,
  IconQuestionMark,
  IconRobot,
  IconUser,
} from "@tabler/icons-react";
import { promptProvenance } from "./promptSource";

const ICONS = {
  robot: IconRobot,
  bulb: IconBulb,
  user: IconUser,
  plug: IconPlug,
  question: IconQuestionMark,
};

/**
 * Who created a prompt, as one icon.
 *
 * An icon rather than a column of text on purpose: the table is already too narrow for its badges,
 * and "was this mine or theirs" is a question you answer by scanning, not by reading. The full
 * sentence — who, through which interface, when — is on the tooltip and in the edit modal.
 */
export default function PromptSourceIcon({ prompt, size = 20 }) {
  const provenance = promptProvenance(prompt);
  if (!provenance) return null;

  const Icon = ICONS[provenance.icon] ?? IconQuestionMark;

  return (
    <Tooltip label={provenance.sentence} withArrow multiline w={280}>
      <ThemeIcon
        size={size}
        radius="sm"
        variant="light"
        color={provenance.color}
        style={{ cursor: "help" }}
      >
        <Icon size={size * 0.65} stroke={1.5} />
      </ThemeIcon>
    </Tooltip>
  );
}
